<div class="imageBox position-relative">
    <button mat-dialog-close class="btn position-absolute shadow-none text-dark top-0 fs-4 end-0"><i class="fa-solid fa-xmark"></i></button>
    <img src="{{apiUrl+'/'+data}}">
</div>